import React, { useEffect, useState } from "react";
import "components/App.css";
import AppRouter from "components/Router";
import { authService } from "../myfirebase";
import CheckYourEmail from "./CheckYourEmail";

function App() {
  const [init, setInit] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showCheckYourEmail, setShowCheckYourEmail] = useState(false);
  const [userEmailAddress, setUserEmailAddress] = useState("");

  useEffect(() => {
    authService.onAuthStateChanged((user) => {
      if (user && authService.currentUser.emailVerified) {
        setIsLoggedIn(true);
        setShowCheckYourEmail(false);
      } else if (user) {
        setIsLoggedIn(true);
        setShowCheckYourEmail(true);
        setUserEmailAddress(authService.currentUser.email);
      } else {
        setIsLoggedIn(false);
        setShowCheckYourEmail(false);
      }
      setInit(true);
    });
  }, []);

  return (
    <>
      <div style={{ height: "60px" }} />
      {showCheckYourEmail ? (
        <CheckYourEmail userEmailAddress={userEmailAddress} />
      ) : (
        <></>
      )}
      {init ? (
        <>
          <AppRouter isLoggedIn={isLoggedIn} />
        </>
      ) : (
        <>
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              backgroundColor: "#252525",
              height: "100vh",
              width: "100vw",
            }}
          >
            <img
              src="/logo2.png"
              height="100px"
              alt="logo2"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-50px",
                marginLeft: "-50px",
              }}
            />
          </div>
        </>
      )}
    </>
  );
}

export default App;
